<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="SAPCustomerMaterialMappings/page">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editPage.open(0)">新建</el-button>
        <el-button icon="el-icon-download" type="primary" plain @click="downloadExcel()">下载导入模板</el-button>
        <el-upload
            :action="uploadUrl"
            :headers="uploadHeaders"
            :before-upload="beforeAvatarUpload"
            :disabled="disabled"
            :on-error="handlerError"
            :on-exceed="onExceed"
            :on-progress="onProgress"
            :on-success="handleSuccess"
            :show-file-list="false"
            accept=".xlsx"
            style="display: inline-block;margin: 0 5px">
          <el-button :loading="importLoading" icon="el-icon-upload2" type="success">导入</el-button>
        </el-upload>
        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="客户物料编号">
            <el-input v-model.trim="filter.customerMaterialNo" clearable/>
          </vm-search>
          <vm-search label="客户名称">
            <el-input v-model.trim="filter.customerName" clearable/>
          </vm-search>
          <vm-search label="SAP物料编号">
            <el-input v-model.trim="filter.materialNo" clearable/>
          </vm-search>
          <vm-search label="箱号">
            <el-input v-model.trim="filter.packageNo" clearable/>
          </vm-search>
          <vm-search label="客户物料描述">
            <el-input v-model.trim="filter.customerMaterialDesc" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="customerName" align="center" width="200" label="客户名称"/>
      <el-table-column
          prop="customerMaterialNo"
          align="center"
          width="150"
          show-overflow-tooltip
          label="客户物料编号"/>
      <el-table-column
          prop="customerMaterialDesc"
          show-overflow-tooltip
          align="center"
          width="400"
          label="客户物料描述"/>
      <!--      <el-table-column prop="unit" align="center" width="140" label="客户物料单位"/>-->
      <!--      <el-table-column prop="packageNo" align="center" width="140" label="箱号"/>-->
      <el-table-column prop="materialNo" align="center" width="140" label="SAP物料编号"/>
      <el-table-column prop="materialDesc" align="center" width="400" label="SAP物料描述"/>
      <!--      <el-table-column prop="sapUnit" align="center" width="140" label="SAP物料单位"/>-->
      <el-table-column prop="salesCountry" align="center" width="80" label="销售国家">
        <template slot-scope="scope">
          <span>{{constant.salesCountrys[scope.row.salesCountry]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createType" align="center" label="创建方式">
        <template slot-scope="scope">
          <el-tag>
            {{scope.row.createType === 10 ? "手工创建":"导入"}}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" @click="edit(scope.row)">编辑</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <s-a-p-customer-material-mapping-edit ref="editPage" @save-success="getList(-1)"/>
    <package-no-edit ref="editPackageNo" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import loginUtil from "@/util/loginUtil";
  import constant from "@/util/constant";
  import SAPCustomerMaterialMappingEdit
    from "@/views/information/SAPCustomerMaterialMapping/SAPCustomerMaterialMappingEdit";
  import PackageNoEdit from "@/views/information/SAPCustomerMaterialMapping/PackageNoEdit";

  export default {
    name: "SAPCustomerMaterialMapping",
    components: {PackageNoEdit, SAPCustomerMaterialMappingEdit, VmTable, VmSearch},
    data() {
      return {
        constant,
        show: "",
        importLoading: false,
        exportLoading: false,
        uploadUrl: window.config.basicServerUrl + "SAPCustomerMaterialMappings/importExcel",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        disabled: false,
        filter: {
          materialNo: "",
          customerMaterialNo: "",
          packageNo: "",
          customerNo: "",
          customerName: "",
          salesOrgan: "",
          salesChannel: "",
          customerMaterialDesc:"",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","SAPCustomerMaterialMappings",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      edit(row) {
        // if (row.createType===10) {
        this.$refs.editPage.open(row.pkid);
        // }else {
        //   this.$refs.editPackageNo.open(row.pkid);
        // }
      },
      //导出
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","SAPCustomerMaterialMappings/exportData", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      //下载导入模板
      downloadExcel() {
        window.open("/publicFile/客户物料关系导入模板.xlsx");
      },
      //导入
      beforeAvatarUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".xlsx") {
          this.$message.error("请上传.xlsx文件类型");
        }
      },
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
